import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import _constantUtil from '../utils/Constant';
import Loader from '../components/partials/Loader';
import config from '../config/config';
import mobileBar from '../assets/images/232213.jpg'

const {
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    EMPTY_STRING: emptyString,
    VERIFY_OTP_END_POINT,
    ONE,
    ZERO,
    RESEND_OTP_END_POINT,
} = _constantUtil;

function VerifyOTP() {
    const location = useLocation();
    const email = location.state?.email || emptyString;

    const [loading, setLoading] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);

    const MAX_RESEND_TIME = 59;
    const MAX_OTP_LENGTH = 6;
    const navigate = useNavigate();
    const storedThemeMode = sessionStorage.getItem('themeMode');
    const [otp, setOtp] = useState([emptyString, emptyString, emptyString, emptyString, emptyString, emptyString]);
    const [resendTimer, setResendTimer] = useState(MAX_RESEND_TIME);
    const [resendDisabled, setResendDisabled] = useState(falseValue);

    //* resend OTP Timer
    useEffect(() => {
        let intervalId;
        if (resendTimer > 0) {
            intervalId = setInterval(() => {
                setResendTimer(prevTime => prevTime - ONE);
            }, 1000);
            setResendDisabled(trueValue);

        } else {
            setResendDisabled(falseValue);
        }

        return () => clearInterval(intervalId);
    }, [resendTimer]);

    //* handle change
    const handleChange = (event, index) => {
        const value = event.target.value;
        const newOtp = [...otp];

        if (/[0-9]/.test(value) || value === emptyString) {
            newOtp[index] = value;
            setOtp(newOtp);

            //* move focus to next input if a number is entered
            if (value && index < MAX_OTP_LENGTH - ONE) {
                document.getElementById(`otp__digit_${index + ONE}`).focus();
            }
        }
    };

    //* handle backspace separately
    const handleKeyDown = (event, index) => {
        if (event.key === 'Backspace') {
            const newOtp = [...otp];

            //* If input is empty, move focus back and clear the previous one
            if (!otp[index] && index > ZERO) {
                newOtp[index - ONE] = emptyString;
                setOtp(newOtp);
                document.getElementById(`otp__digit_${index - ONE}`).focus();
            } else {
                newOtp[index] = emptyString;
                setOtp(newOtp);
            }
        }
    };

    //* handle paste
    const handlePaste = (event, index) => {
        event.preventDefault();
        const pasteData = event.clipboardData.getData('text');
        const newOtp = [...otp];
        const digits = pasteData.split('').filter(char => /[0-9]/.test(char));

        digits.forEach((digit, i) => {
            if (index + i < newOtp.length) {
                newOtp[index + i] = digit;
            }
        });

        setOtp(newOtp);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const otpCode = otp.join('');

        //* check if OTP is valid
        if (otpCode.length !== MAX_OTP_LENGTH) {
            toast.error('Please enter a valid OTP');
            return;
        }

        //* set loading to true
        setLoading(trueValue);
        setDisableButton(trueValue);

        //* create data
        const data = {
            email,
            otp: otpCode
        };

        try {
            const res = await axios.post(`${config.appBaseUrl + VERIFY_OTP_END_POINT}`, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const result = res.data;
            if (result.status) {
                toast.success(result.message);
                setTimeout(() => {
                    navigate('/dashboard');
                    setLoading(falseValue);
                    setDisableButton(falseValue);
                }, 2000);
                localStorage.setItem('vendor_super_token', result.data.token);
                localStorage.setItem('vendor_super_data', JSON.stringify(result.data.vendor));
            } else {
                toast.error(result.message);
                setTimeout(() => {
                    setLoading(falseValue);
                    setDisableButton(falseValue);
                }, 2500);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    //* handle resend OTP
    const handleResendOTP = (event) => {
        event.preventDefault();
        setLoading(trueValue);
        setDisableButton(trueValue);
        setResendDisabled(trueValue);
        setOtp([emptyString, emptyString, emptyString, emptyString, emptyString, emptyString])
        setResendTimer(59);

        //* create data
        const data = {
            email,
        };

        axios.post(`${config.appBaseUrl + RESEND_OTP_END_POINT}`, data, {
        }).then(res => {
            const result = res.data
            if (result.status) {
                toast.success(result.message);
                setLoading(falseValue);
                setDisableButton(falseValue);
                setOtp([emptyString, emptyString, emptyString, emptyString, emptyString, emptyString])
                setResendTimer(MAX_RESEND_TIME);
            } else {
                toast.error(result.message);
                setLoading(falseValue);
                setDisableButton(falseValue);
                setResendDisabled(falseValue);
                return;
            }
        }).catch(error => {
            toast.error(error);
            setLoading(falseValue);
            setDisableButton(falseValue);
            setResendDisabled(falseValue);
        });
    };

    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />
            <div className="grid">
                <div className="order__left centered d-flex align-items-center justify-content-center">
                    <form onSubmit={handleSubmit}>
                        <div className="form">
                            <div className="logo">
                                <h3 className='text-center'>Hire a Vendor for professionals</h3>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <p className='text-center'>We’ve sent a verification code to your email. Please enter it to proceed.</p>
                            </div>
                            <div className='otp-container mb-3'>
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        id={`otp__digit_${index}`}
                                        type='text'
                                        className={`otp__digit mx-3  otp__digit_${index} ${storedThemeMode === 'dark' ? 'text-white' : 'text-dark'}`}
                                        maxLength='1'
                                        value={digit}
                                        autoComplete='off'
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        onPaste={(e) => handlePaste(e, index)}
                                    />
                                ))}
                            </div>
                            <div className='text-golden resend-otp-email text-underline font-weight-medium  w-100 mb-3'>
                                <div className='d-flex justify-content-end'>
                                    <button onClick={handleResendOTP} type='button' style={{ background: 'transparent', border: 'none' }} disabled={resendDisabled}>
                                        Resend OTP
                                    </button>
                                    {resendTimer > ZERO && (
                                        <span>&nbsp;{resendTimer} seconds</span>
                                    )}
                                </div>
                            </div>
                            <button className="login__button" disabled={disableButton}>
                                {!loading ? 'Verify' : <Loader />}
                            </button>
                        </div>
                    </form>
                </div>
                <div className="order__right centered no__overflow d-none d-md-block">
                    <img
                        className="img"
                        src={mobileBar}
                        alt="mobile-bar"
                    />
                </div>
            </div>
        </>
    );
}

export default VerifyOTP;